import React from "react";
import closeImg from "../../asserts/img/closeX.svg";
import { observer, inject } from "mobx-react";
import { useTranslation } from "react-i18next";
import searchImg from "../../asserts/img/search.svg";
import Input from "./Input";
import { endOfDay } from "date-fns";

// True when `search` is empty or any of `fields` in `row` contains it (trimmed, case-insensitive)
export const matchesSearch = (row, fields, search) => {
  const term = String(search ?? "").trim().toLowerCase();
  if (!term) return true;

  return fields.some((field) => {
    const value = row?.[field];
    return value !== null && value !== undefined && String(value).toLowerCase().includes(term);
  });
};

// True when `value` (a date) falls inside `range` = [from, to]; a missing bound is not checked.
// `to` includes the whole day.
export const matchesDateRange = (value, range) => {
  const [from, to] = range || [];
  const time = new Date(value).getTime();

  if (from && time < new Date(from).getTime()) return false;
  if (to && time > endOfDay(new Date(to)).getTime()) return false;
  return true;
};

// Controlled by the page: `value` is the search that is currently applied
const SearchInput = ({ value = "", handleSearchChange }) => {
  const { t, i18n } = useTranslation("common");
  const isRtl = i18n.dir() === "rtl";

  const handleClear = () => {
    handleSearchChange("");
  };

  const handleChange = (e) => {
    handleSearchChange(e.target.value);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        marginInlineStart: 5,
        height: 42,
        position: "relative",
      }}>
      <Input
        placeholder={t("search")}
        onChange={handleChange}
        startImg={searchImg}
        value={value}
        style={{
          margin: 0,
          textAlign: "right",
          height: 42,
          overflow: "hidden",
          minWisth: 230,
          alignItems: "center",
        }}
      />
      {!!value && (
        <img
          src={closeImg}
          alt="clear-input"
          onClick={handleClear}
          style={{
            width: 14,
            height: 14,
            position: "absolute",
            left: isRtl && 10,
            right: !isRtl && 10,
            top: 0,
            margin: "auto 0",
            bottom: 0,
          }}
        />
      )}
    </div>
  );
};

export default inject()(observer(SearchInput));
